import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  useLoaderData,
} from "react-router-dom";
import ScoreReport from "./pages/ScoreReport/ScoreReport";
import SurveyReport from "./pages/SurveyReport/SurveyReport";
import Home from "./pages/Home/Home";
import { exchangeToken, v2Clients } from "./API/nimble";
import {
  Alert,
  Box,
  createTheme,
  CssBaseline,
  Stack,
  ThemeProvider,
  Typography,
} from "@mui/material";
import Header from "./component/Header";
import { FormProvider } from "./component/FormContext";
import { SnackbarProvider } from "notistack";
import { useState } from "react";
import { ActionContext } from "./component/ActionContext";
import { useRouteError } from "react-router-dom";
import { setToken } from "./API/tokenStore";

async function loader({ request }) {
  const url = new URL(request.url);

  const authID = url.searchParams.get("authID");
  const corporationID = url.searchParams.get("corporationID");


  const PCID = url.searchParams.get("PCID");
  const year = url.searchParams.get("year");
  const month = url.searchParams.get("month");
  const autoFetch = url.searchParams.get("autoFetch");
  const urlInfo = url.searchParams.get("urlInfo");

  const toBeChangeToURLV2 = await v2Clients();

  const isV2 = toBeChangeToURLV2.includes(urlInfo);
  const clientNameUrlVersion = isV2 ? "v2" : "v1";

  let { token, minutesToExpire, refAuth } = await exchangeToken(
    authID,
    clientNameUrlVersion
  );
  if (token) {
    setToken(token, minutesToExpire, refAuth, clientNameUrlVersion, isV2);
  }


  return {
    token,
    corporationID,
    PCID,
    month,
    year,
    autoFetch: autoFetch?.toLocaleLowerCase() === "true",
    urlInfo,
    clientNameUrlVersion
  };
}

function ErrorPage() {
  const error = useRouteError();

  return (
    <Box sx={{ p: 4 }}>
      <Alert severity="error">{error?.statusText}</Alert>
    </Box>
  );
}

function Layout() {
  const loaderData = useLoaderData();
  const { token } = loaderData;
  const [actions, setActions] = useState(null);
  const [PCS, setPCS] = useState([]);
  return (
    <FormProvider>
      <ActionContext.Provider value={{ setActions }}>
        <SnackbarProvider
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          maxSnack={1}
        >
          <Stack height={"100%"} gap={2}>
            <Header PCS={PCS} setPCS={setPCS} actions={actions} />
            <Outlet context={{ PCS, token }} />
          </Stack>
        </SnackbarProvider>
      </ActionContext.Provider>
    </FormProvider>
  );
}

const router = createBrowserRouter([
  {
    id: "layout",
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    loader: loader,
    children: [
      {
        path: "score",
        element: <ScoreReport />,
      },
      {
        path: "survey",
        element: <SurveyReport />,
      },
    ],
  },
]);

const theme = createTheme({
  typography: {
    fontFamily: `'Poppins', sans-serif`,
    fontSize: 13,
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "filled",
        size: "small",
      },
      styleOverrides: {
        root: {
          minWidth: 100,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: "black",
          backgroundColor: "#88ceeb",
          "&:hover": {
            backgroundColor: "#88ceeb",
          },
        },
      },
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />{" "}
    </ThemeProvider>
  );
}
